import {Component, Input} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
// Enum pour définir les couleurs possibles
export enum SectionColor {
  White = 'white',
  Blue = 'blue',
  Gray = 'gray'
}
@Component({
  selector: 'app-section',
  standalone: true,
  imports: [
    NgClass,
    NgIf
  ],
  templateUrl: './section.component.html',
  styleUrl: './section.component.css'
})
export class SectionComponent {
  @Input() id: string = '';
  @Input() titre: string = '';
  @Input() sousTitre: string = '';
  @Input() theme: SectionColor = SectionColor.White; // Couleur par défaut : blanc
}
